import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect, useState } from "react";

export const PodiumScript = () => {
  const router = useRouter();
  const [hasScrolled, setHasScrolled] = useState(false);

  const isHome = router.pathname === "/";
  const isCart = router.pathname === "/cart";
  const isProductOpen = !!router.query.product;

  // Hide podium on home page until user scrolls past the hero
  useEffect(() => {
    if (!isHome) {
      setHasScrolled(false);
      return;
    }

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setHasScrolled(true);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  if (router.pathname.startsWith("/admin")) {
    return null;
  }

  const shouldHide = isCart || isProductOpen || (isHome && !hasScrolled);

  return (
    <>
      {shouldHide && (
        <style
          // biome-ignore lint/security/noDangerouslySetInnerHtml: static CSS to hide Podium widget
          dangerouslySetInnerHTML={{
            __html: `
          podium-bubble,
          #podium-bubble,
          [id^="podium-bubble"],
          #podium-prompt,
          [id^="podium-prompt"] {
            visibility: hidden !important;
          }
        `,
          }}
        />
      )}
      <Script
        defer
        src="https://connect.podium.com/widget.js#ORG_TOKEN=54e1f4ab-1320-45c7-bd53-1a4580d4146c"
        id="podium-widget"
        data-organization-api-token="54e1f4ab-1320-45c7-bd53-1a4580d4146c"
        strategy="lazyOnload"
      />
    </>
  );
};
